<template>
  <div class="tw-mb-10">
    <h2>
      <slot name="title" />
    </h2>
    <div
      class="tw-bg-color3 tw-p-4 tw-rounded-xl tw-mb-4 md:tw-p-10 md:tw-rounded-3xl"
    >
      <slot />
    </div>
    <div>
      <slot name="switch" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>
